import React from "react";

/**
 * ─── PageHeader ────────────────────────────────────────────────────────────
 * The ONE canonical page header for every Owner Console page (PDR v2.1 §8).
 * Replaces every legacy dark hero banner.
 *
 * Layout:
 *   ┌────────────────────────────────────────────────────────────────────┐
 *   │  EYEBROW                                                            │
 *   │  Title (22 px / 600 / -0.015em tracking)                            │
 *   │  Description (14 px / 500 · muted · max-width 720)                  │
 *   ├────────────────────────────────────────────────────────────────────┤
 *   │                                       [ actions ] on the right     │
 *   └────────────────────────────────────────────────────────────────────┘
 *
 * Props
 *   eyebrow      short uppercase context label
 *   title        page title (H1 equivalent)
 *   description  one-sentence description
 *   actions      ReactNode — usually one or two Buttons + a Refresh
 *   testId
 */
export default function PageHeader({ eyebrow, title, description, actions, testId }) {
  return (
    <header className="ds-pageheader" data-testid={testId || "page-header"}>
      <div className="ds-pageheader__body">
        {eyebrow && (
          <div className="ds-pageheader__eyebrow" data-testid="page-header-eyebrow">{eyebrow}</div>
        )}
        <h1 className="ds-pageheader__title" data-testid="page-header-title">{title}</h1>
        {description && (
          <p className="ds-pageheader__desc" data-testid="page-header-desc">{description}</p>
        )}
      </div>
      {actions && (
        <div className="ds-pageheader__actions" data-testid="page-header-actions">{actions}</div>
      )}
    </header>
  );
}
